import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.p-dialog-content {
  min-height: 0% !important;
  max-height: 100% !important;
  display: grid !important;
}

.app-modal {
  & .header {
    color: ${dt('appModal.header.color')};
    font-size: ${dt('appModal.header.fontSize')};
    line-height: ${dt('appModal.header.lineHeight')};
    font-weight: ${dt('appModal.header.fontWeight')};

    & .header-title-block .subtitle {
      color: ${dt('text.muted.color')};
      font-size: ${dt('appModal.header.subtitle.fontSize')};
      line-height: ${dt('appModal.header.subtitle.lineHeight')};
    }

    & .header-title-block .title {
      color: ${dt('appModal.header.title.color')};
      font-size: ${dt('appModal.header.title.fontSize')};
      line-height: ${dt('appModal.header.title.lineHeight')};
      font-weight: ${dt('appModal.header.title.fontWeight')};
      margin: 0;
    }

    & .close-icon {
      & i {
        font-size: ${dt('appModal.header.closeIcon.fontSize')};
        font-weight: ${dt('appModal.header.closeIcon.fontWeight')};
        color: ${dt('appModal.header.closeIcon.color')};
        cursor: pointer;
      }
    }
  }

  & .content {
    color: ${dt('appModal.content.color')};
    font-weight: ${dt('appModal.content.fontWeight')};
    font-size: ${dt('appModal.content.fontSize')};
    line-height: ${dt('appModal.content.lineHeight')};
    padding: ${dt('appModal.content.padding')};
    & h1, & h2, & h3, & h4, & h5, & h6 {
      color: ${dt('appModal.content.header.color')};
      font-size: ${dt('appModal.content.header.fontSize')};
      line-height: ${dt('appModal.content.header.lineHeight')};
    }
  }

}`;
